import { Phone, X, Menu } from "lucide-react";
import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { path: "/", label: "Главная" },
    { path: "/products", label: "Продукция" },
    { path: "/services", label: "Услуги" },
    { path: "/contacts", label: "Контакты" },
    { path: "/support", label: "Поддержка" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-white/95 backdrop-blur shadow-sm" : "bg-white"
        } border-b border-slate-200`}
      data-testid="main-navigation"
    >
      <div className="container-custom">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <div className="w-10 h-10 rounded-sm flex items-center justify-center">
              {/* <span className="text-white font-bold text-xl">P</span> */}
              <img 
                src="/logo-transparent.png"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="font-bold text-xl tracking-tight text-slate-900">Promtemica</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium uppercase tracking-wide transition-colors hover:text-[#0056D2] ${location.pathname === link.path ? "text-[#0056D2]" : "text-slate-700"
                  }`}
                data-testid={`nav-link-${link.path.replace("/", "") || "home"}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Contact Button */}
          <div className="hidden md:flex items-center gap-4">
            <a href="tel:+74734168249" className="flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-[#0056D2] transition-colors">
              <Phone size={16} />
              <span>+7 (473) 416-82-49</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-slate-700"
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden border-t border-slate-200 py-4 animate-fade-in">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block py-3 text-sm font-medium uppercase tracking-wide ${location.pathname === link.path ? "text-[#0056D2]" : "text-slate-700"
                  }`}
                data-testid={`mobile-nav-link-${link.path.replace("/", "") || "home"}`}
              >
                {link.label}
              </Link>
            ))}
            <a href="tel:+74734168249" className="flex items-center gap-2 py-3 text-sm font-medium text-slate-700">
              <Phone size={16} />
              <span>+7 (473) 416-82-49</span>
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};